/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import ProvinceEdit from "views/content/ProvinceEdit";
import DealEdit from "views/content/DealEdit";
import LegendEdit from "views/content/LegendEdit";
import LegendView from "views/content/LegendView";
import { RequireNonGuest } from "components/Auth/RequireAuth.js";

const APP_BASE_RAW = process.env.PUBLIC_URL || "";
const APP_BASE =
  APP_BASE_RAW && APP_BASE_RAW !== "/" ? APP_BASE_RAW.replace(/\/+$/, "") : "";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        const routePath = prop.path?.startsWith("/") ? prop.path.slice(1) : prop.path;
        return (
          <Route path={routePath} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          outterLink: "https://www.karadenizdestinasyonu.com.tr/",
          imgSrc: require("../assets/img/brand/blue.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(routes)}
          {}
          <Route
            path="content/provinces/new"
            element={
              <RequireNonGuest>
                <ProvinceEdit />
              </RequireNonGuest>
            }
          />
          <Route
            path="content/provinces/:id"
            element={
              <RequireNonGuest>
                <ProvinceEdit />
              </RequireNonGuest>
            }
          />
          <Route
            path="content/deals/new"
            element={
              <RequireNonGuest>
                <DealEdit />
              </RequireNonGuest>
            }
          />
          <Route
            path="content/deals/:id"
            element={
              <RequireNonGuest>
                <DealEdit />
              </RequireNonGuest>
            }
          />
          <Route
            path="content/legends/:id"
            element={
              <RequireNonGuest>
                <LegendEdit />
              </RequireNonGuest>
            }
          />
          <Route path="content/legends/view/:id" element={<LegendView />} />
          <Route
            path="*"
            element={<Navigate to={`${APP_BASE}/admin/index`} replace />}
          />
        </Routes>
        <AdminFooter />
      </div>
    </>
  );
};

export default Admin;
